module.exports = __webpack_public_path__ + "img/icon-fb.1d34a819.svg";